<template>
  <div class="timeline">
    <!-- sticky cta form -->
    <div class="sticky-cta">
      <a
        href="#"
        @click.prevent="StickyForm(true)"
        @keydown.esc="StickyForm(false)"
        >{{ strings.sticky_cta_evolutie }}
      </a>
    </div>

    <!-- sticky form -->
    <div class="sticky-form">
      <div class="sticky-form-shape mask-right">
        <div class="sticky-form-col">
          <a href="#" @click.prevent="StickyForm(false)">
            <svg
              width="47"
              height="44"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke="#000"
                stroke-width="2"
                d="M2.6976 1.2835l43.0645 41.9334M44.3669 1.2835L1.3024 43.217"
              />
            </svg>
          </a>
        </div>
        <div class="sticky-form-col">
          <h5>{{ strings.sticky_headline_evolutie }}</h5>
          <!-- form -->
          <form
            class="form-styles form-styles--dark form-styles--w70"
            @submit="submitForm"
            action="#"
            method="post"
          >
            <input
              type="hidden"
              id="form_type"
              name="form_type"
              value="phase"
            />
            <input
              type="text"
              v-model="user_name"
              name="user_name"
              value=""
              :placeholder="strings.programeaza_intalnire_nume"
            />
            <input
              type="email"
              v-model="user_email"
              name="email"
              value=""
              :placeholder="strings.programeaza_intalnire_email"
            />
            <input
              type="tel"
              v-model="user_phone"
              pattern="[0-9]{4}[0-9]{3}[0-9]{3}"
              name="tel"
              value=""
              :placeholder="strings.programeaza_intalnire_tel"
            />
            <!-- newsletter -->
            <div class="gdpr_wrapper gdpr_wrapper--black">
              <input
                type="checkbox"
                id="label_subscribe_newsletter"
                name="label_subscribe_newsletter"
                value="true"
                required
              />
              <span class="checkmark"></span>
              <label
                class="label_subscribe_newsletter"
                for="label_subscribe_newsletter"
                >{{ strings.subscribe_newsletter }}</label
              >
            </div>

            <!-- t&c -->
            <div class="gdpr_wrapper gdpr_wrapper--black">
              <input
                type="checkbox"
                id="label_accept_tc_1"
                name="label_accept_tc_1"
                value="Accept T&C"
                required
              />
              <span class="checkmark"></span>
              <label class="label_accept_tc_1" for="label_accept_tc_1">{{
                strings.programeaza_intalnire_accept_termeni
              }}</label>
            </div>
            <input
              type="submit"
              :value="strings.programeaza_intalnire_accept_trimite"
            />
          </form>
          <h6>
            {{ strings.etape_newsletter_thanks }}
          </h6>
        </div>
      </div>
    </div>

    <div class="section-wrapper timeline-header">
      <div class="timeline-header-shadow mask-left active">
        <div class="header-title">
          <h2>
            {{ strings.evolutie_h2 }}
          </h2>
          <h3>{{ strings.evolutie_h3 }}</h3>
        </div>
      </div>
    </div>

    <!-- content -->
    <div class="timeline-content">
      <div class="timeline-controller" data-index="0">
        <span class="timeline-controller-prev" @click="controlWrapper('prev')"
          ><svg
            width="72"
            height="16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M.2929 7.2929c-.3905.3905-.3905 1.0237 0 1.4142l6.364 6.364c.3905.3905 1.0236.3905 1.4142 0 .3905-.3906.3905-1.0237 0-1.4143L2.4142 8 8.0711 2.343c.3905-.3905.3905-1.0237 0-1.4142-.3906-.3905-1.0237-.3905-1.4142 0L.2929 7.293zM72 7H1v2h71V7z"
              fill="#000"
            /></svg
        ></span>
        <span class="timeline-controller-next" @click="controlWrapper('next')"
          ><svg
            width="72"
            height="16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M.2929 7.2929c-.3905.3905-.3905 1.0237 0 1.4142l6.364 6.364c.3905.3905 1.0236.3905 1.4142 0 .3905-.3906.3905-1.0237 0-1.4143L2.4142 8 8.0711 2.343c.3905-.3905.3905-1.0237 0-1.4142-.3906-.3905-1.0237-.3905-1.4142 0L.2929 7.293zM72 7H1v2h71V7z"
              fill="#000"
            /></svg
        ></span>
      </div>
      <div class="timeline-project timeline-wrapper" data-index="0">
        <!-- slide precupeti -->
        <div class="timeline-project-slide">
          <h4 class="timeline-project-title">Precupeții Vechi</h4>

          <!-- project stats block -->
          <div
            class="project-details-block project-details-block--row our-projects-block"
          >
            <!-- item -->
            <div class="project-details-block-item">
              <svg
                width="133"
                height="88"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  width="125.765"
                  height="45.1551"
                  rx="22.4908"
                  transform="matrix(.99289 .11906 -.16479 .98633 7.441 15)"
                  fill="#F9DF41"
                />
                <path
                  d="M24 38.3333L61.7391 1H108M24 38.3333h46.6667m-46.6667 0v8.9276h14.2029c4.058 0 5.4496 8.5455 5.2754 14.6087-.1615 5.6184 0 13.3913-5.2754 13.3913H24v10.1449h46.6667V75.2609H58.087c-4.4638 0-6.087-2.8406-6.087-13.3913 0-9.7662.8116-14.6087 6.087-14.6087h12.5797m0-8.9276L108 1M70.6667 38.3333v8.9276M108 1v8.9275L70.6667 47.261"
                  stroke="#000"
                  stroke-width="1.6232"
                />
                <path
                  d="M108 36.3046L70.6665 76.0727v9.3333L108 46.0437v-9.7391zM24 75.2611L43.0725 55.377M108 35.8988h-9.3336c-3.6519 0-10.4698.3246-8.5219-8.116M60.522 63.8988c.9739-.3247 19.884-19.343 29.2174-28.8116"
                  stroke="#000"
                  stroke-width="1.6232"
                />
              </svg>
              <h6>
                <span
                  >{{ this.content.precupeti.phaseItems["steel"] }} <br />{{
                    strings.toneotel
                  }}</span
                >
              </h6>
            </div>
            <!-- item -->
            <div class="project-details-block-item">
              <svg
                width="133"
                height="84"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  width="125.765"
                  height="45.1551"
                  rx="22.4908"
                  transform="matrix(.99289 .11906 -.16479 .98633 7.441 10)"
                  fill="#F9DF41"
                />
                <path
                  d="M20.3142 25.262l-.0019-.0023-3.8188-4.4397-.0001-.0001-1.4517-1.6886a.0385.0385 0 00-.0019-.0023c-.3054-.3632-.3436-.8577-.1291-1.2235l.0028-.005 9.5447-16.5364.0011-.0018c.2213-.3761.6757-.5838 1.1242-.5024l.0011.0002 31.7378 5.894.0021.0003c1.5275.2924 2.967.831 4.3202 1.5978a.7623.7623 0 01.0039.0022l9.8013 5.6996.0054.0031c3.3538 1.9171 6.0257 4.8613 7.6238 8.3768l.0001.0003 4.4865 9.8578h-.0001l.0057.0121c.1044.2201.1119.5093-.0067.7721l-.0191.0423-.0143.044a2.4505 2.4505 0 00-.0122.0387l-.0048.0155-.0041.0131-.0043.0139-3.4588 5.9876-.0002.0004-5.7284 9.9296-.0004.0006-2.2625 3.9298-.0021.0035c-.172.2884-.4672.4797-.7897.5134h-.0758l-.0411.004-10.6849 1.049c-.6184.0484-1.2287.0927-1.8079.0929-3.2711-.0237-6.4661-.8699-9.2686-2.5102l-.0047-.0027-9.8093-5.6566-.0053-.003c-1.3452-.7628-2.5339-1.7488-3.5447-2.9395l-.0017-.0021-6.1582-7.208-.0005-.0005-3.8184-4.4626-.0005-.0006-5.7279-6.7067z"
                  stroke="#000"
                  stroke-width="1.6848"
                />
                <path
                  d="M9.26 73.1507c-.2014-.2816-.254-.6448-.149-.9623.0002-.0003.0003-.0005.0003-.0008l.4294-1.2871v-.0002l3.3865-10.1604.0012-.0033c.1458-.4189.5631-.7171 1.0167-.7171H16.6969V29.511l11.6814 13.6509v16.8576h27.0699c.3355.0385.9014.054 1.5156.0602.6756.0067 1.4732.0022 2.2334-.0067a229.795 229.795 0 002.6699-.0479l.1785-.0043.047-.0011.0053-.0002h9.9734v-.9707c1.9833-.2659 3.7252-1.4681 4.731-3.1948l.0018-.0032 6.9486-12.0489v16.2176h5.5038V38.173c0-.5852.4822-1.067 1.067-1.067h10.6715c1.724.0894 3.359.7696 4.637 1.9564l14.612 14.9234a.0662.0662 0 01.003.0025c1.089 1.1319 1.695 2.6399 1.695 4.1865v10.5496a7.695 7.695 0 01-.191 1.7117c-.521 2.047-2.493 3.4179-4.6 3.1796l-.047-.0053h-4.709v.8424c0 4.8091-3.895 8.7049-8.705 8.7049-4.8102 0-8.7051-3.8958-8.7051-8.7049v-.8424H58.9297v.8424c0 4.8091-3.8949 8.7049-8.7049 8.7049-4.8099 0-8.7049-3.8958-8.7049-8.7049v-.8424h-5.5037v.8424c0 4.8091-3.895 8.7049-8.7049 8.7049-4.81 0-8.7049-3.8958-8.7049-8.7049v-.8424h-8.4803c-.3353 0-.6578-.1678-.8657-.4591l-.0005-.0006z"
                  stroke="#000"
                  stroke-width="1.6848"
                />
              </svg>
              <h6>
                <span
                  >{{
                    this.content.precupeti.phaseItems["concrete"]
                  }}
                  m3<br />{{ strings.concrete }}</span
                >
              </h6>
            </div>
            <!-- item -->
            <div class="project-details-block-item">
              <svg
                width="134"
                height="86"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  width="125.765"
                  height="45.1552"
                  rx="22.4909"
                  transform="matrix(.99289 .11906 -.16479 .98633 8.2852 14)"
                  fill="#F9DF41"
                />
                <path
                  d="M47.3685 3.7779c-6.7658 6.2454 1.0843 18.2157 5.8551 23.4201 9.3681-8.8477 11.0593-16.264 9.1076-20.8179-1.3011-3.0361-8.1969-8.8476-14.9627-2.6022z"
                  stroke="#000"
                  stroke-width="1.7678"
                />
                <circle
                  cx="54.1918"
                  cy="10.4576"
                  r="4.3206"
                  stroke="#000"
                  stroke-width="1.7678"
                />
                <path
                  d="M59.7896 27.582h23.1196c7.8577 0 14.2275 6.3699 14.2275 14.2275v0c0 7.8576-6.3698 14.2275-14.2275 14.2275H59.7896M84.645 56.037H25.9999c-7.8576 0-14.2274 6.3699-14.2274 14.2275v0c0 7.8576 6.3698 14.2275 14.2274 14.2275h74.0261"
                  stroke="#000"
                  stroke-width="2.1266"
                />
                <path
                  d="M102.152 85V72.2405m0 0V55.2278l18.076 8.5064-18.076 8.5063z"
                  stroke="#000"
                  stroke-width="2.0185"
                />
              </svg>
              <h6>
                <span
                  >{{ this.content.precupeti.phaseItems["finish"] }}
                  {{ strings.months }}<br />{{ strings.tofinish }}</span
                >
              </h6>
            </div>
          </div>

          <!-- timeline -->
          <div class="timeline-horizontal">
            <span class="timeline-horizontal-sectiontitle">{{
              strings.evolutie_in_timp
            }}</span>

            <div class="timeline-horizontal-wrapper">
              <ol class="timeline-horizontal--bar" :data-full="stages.precupeti[this.stages.precupeti.length - 1].status === 'Finalizat'">
                <!-- first item -->
                <li
                  class="timeline-horizontal--item"
                  data-list-index="0"
                  :class="stages.precupeti[0].status"
                >
                  <span
                    ><strong>start</strong><br />{{
                      stages.precupeti[0].dateShort
                    }}</span
                  >
                  <span>{{ stages.precupeti[0].title }}</span>
                </li>

                <!-- loop items -->
                <li
                  class="timeline-horizontal--item"
                  v-for="(item, index) in stagesLoop.precupeti"
                  :key="index"
                  :class="item.status"
                  :data-list-index="item.listIndex"
                  @click="openSelected(item.listIndex, item.status)"
                >
                  <span
                    ><strong>{{ item.percentage }}%</strong></span
                  >
                  <span class="hideondesktop cta-search-icon"
                    ><svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 511.999 511.999"
                    >
                      <path
                        d="M508.874 478.708L360.142 329.976c28.21-34.827 45.191-79.103 45.191-127.309C405.333 90.917 314.416 0 202.666 0S0 90.917 0 202.667s90.917 202.667 202.667 202.667c48.206 0 92.482-16.982 127.309-45.191l148.732 148.732c4.167 4.165 10.919 4.165 15.086 0l15.081-15.082c4.165-4.166 4.165-10.92-.001-15.085zM202.667 362.667c-88.229 0-160-71.771-160-160s71.771-160 160-160 160 71.771 160 160-71.771 160-160 160z"
                      /></svg
                  ></span>
                  <span class="hideonmobile underbartitle">{{
                    item.title
                  }}</span>

                  <span class="hideondesktop">
                    <svg
                      viewBox="0 0 24 24"
                      class="icon project-icon shape-codepen"
                    >
                      <use
                        :xlink:href="
                          require('@/assets/sprite-sheet.svg') + '#' + item.icon
                        "
                      ></use>
                    </svg>
                  </span>
                </li>

                <!-- final item -->
                <li
                  class="timeline-horizontal--item"
                  data-list-index="last"
                  :class="
                    stages.precupeti[this.stages.precupeti.length - 1].status
                  "
                  @click="openSelected(last)"
                >
                  <span
                    ><strong>{{ strings.finalizare }}</strong
                    ><br />{{
                      stages.precupeti[this.stages.precupeti.length - 1]
                        .dateShort
                    }}</span
                  >
                  <span>{{
                    stages.precupeti[this.stages.precupeti.length - 1].title
                  }}</span>
                </li>
              </ol>
            </div>

            <div class="timeline-vertical-wrapper">
              <div class="timeline-vertical-actions">
                <span @click="toggleAll(true)">{{
                  strings.deschide_toate
                }}</span>
                /
                <span @click="toggleAll(false)">{{
                  strings.inchide_toate
                }}</span>
              </div>
              <ol class="timeline-vertical">
                <li
                  class="timeline-vertical--item"
                  v-for="(item, index) in stages.precupeti"
                  :key="index"
                  :class="item.status"
                  :data-list-index="item.listIndex"
                  @click="
                    item.slug !== 'autorizatie-de-construire' ||
                    item.slug !== 'building-permit'
                      ? toggleEvent($event, null, item.status)
                      : null
                  "
                >
                  <div class="timeline-vertical--item-row">
                    <span class="timeline-vertical--item-icon">
                      <svg viewBox="0 0 24 24" class="icon shape-codepen">
                        <use
                          :xlink:href="
                            require('@/assets/sprite-sheet.svg') +
                              '#' +
                              item.icon
                          "
                        ></use>
                      </svg>
                    </span>
                    <!-- desktop -->
                    <span class="timeline-vertical--item-title hideonmobile">{{
                      item.title
                    }}</span>
                    <span class="timeline-vertical--item-date hideonmobile"
                      >{{ strings.date }}:
                      <span
                        v-if="
                          item.status === 'Finalizat' || item.status === 'Done'
                        "
                        >{{ item.date }}</span
                      ></span
                    >
                    <span class="timeline-vertical--item-status hideonmobile"
                      >Status:
                      <span
                        class="accent"
                        v-if="
                          item.status !== 'Inchis' && item.status !== 'Closed'
                        "
                        >{{ item.status }}</span
                      ></span
                    >

                    <!-- mobile -->
                    <span class="timeline-vertical--item--mobilewrap">
                      <span class="timeline-vertical--item-title">{{
                        item.title
                      }}</span>
                      <span class="timeline-vertical--item-date"
                        >{{ strings.date }}:
                        <span
                          v-if="
                            item.status === 'Finalizat' ||
                              item.status === 'Done'
                          "
                          >{{ item.date }}</span
                        ></span
                      >
                      <span class="timeline-vertical--item-status"
                        >Status:
                        <span
                          class="accent"
                          v-if="
                            item.status !== 'Inchis' && item.status !== 'Closed'
                          "
                          >{{ item.status }}</span
                        ></span
                      >
                    </span>
                    <span v-if="item.media.length > 0" class="timeline-vertical--item-iconToggle"
                      ><svg
                        v-if="
                          item.slug !== 'autorizatie-de-construire' ||
                            item.slug !== 'building-permit'
                        "
                        width="16"
                        height="36"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.2929 35.7071c.3905.3905 1.0237.3905 1.4142 0l6.364-6.364c.3905-.3905.3905-1.0236 0-1.4142-.3906-.3905-1.0237-.3905-1.4142 0L8 33.5858l-5.6569-5.6569c-.3905-.3905-1.0237-.3905-1.4142 0-.3905.3906-.3905 1.0237 0 1.4142l6.364 6.364zM7 0v35h2V0H7z"
                          fill="#000"
                        /></svg
                    ></span>
                  </div>
                  <div class="timeline-vertical--item-gallery">
                    <img
                      v-if="
                        (item.status === 'Finalizat' ||
                          item.status === 'Done') &&
                          item.slug !== 'autorizatie-de-construire' &&
                          item.slug !== 'building-permit' &&
                          item.media.img_1 !== null
                      "
                      v-bind:src="item.media.img_1"
                      alt=""
                    />
                    <img
                      v-if="
                        (item.status === 'Finalizat' ||
                          item.status === 'Done') &&
                          item.slug !== 'autorizatie-de-construire' &&
                          item.slug !== 'building-permit' &&
                          item.media.img_2 !== null
                      "
                      v-bind:src="item.media.img_2"
                      alt=""
                    />
                    <img
                      v-if="
                        (item.status === 'Finalizat' ||
                          item.status === 'Done') &&
                          item.slug !== 'autorizatie-de-construire' &&
                          item.slug !== 'building-permit' &&
                          item.media.img_3 !== null
                      "
                      v-bind:src="item.media.img_3"
                      alt=""
                    />
                  </div>
                </li>
              </ol>
            </div>
          </div>

          <!-- form -->
          <div class="timeline-form">
            <h4 class="timeline-project-title">
              {{ strings.evolutie_nl_h4 }}
            </h4>
            <h5 class="timeline-project-subtitle">
              {{ strings.evolutie_nl_h5 }}
            </h5>
            <!-- form -->
            <form
              class="form-styles form-styles--dark form-styles--w70"
              @submit="submitForm"
              action="#"
              method="post"
            >
              <input
                type="hidden"
                id="form_type"
                name="form_type"
                value="phase"
              />
              <input
                type="text"
                v-model="user_name"
                name="user_name"
                value=""
                :placeholder="strings.programeaza_intalnire_nume"
              />
              <input
                type="email"
                v-model="user_email"
                name="email"
                value=""
                :placeholder="strings.programeaza_intalnire_email"
              />
              <input
                type="tel"
                v-model="user_phone"
                pattern="[0-9]{4}[0-9]{3}[0-9]{3}"
                name="tel"
                value=""
                :placeholder="strings.programeaza_intalnire_tel"
              />
              <!-- newsletter -->
              <div class="gdpr_wrapper gdpr_wrapper--black">
                <input
                  type="checkbox"
                  id="label_subscribe_newsletter"
                  name="label_subscribe_newsletter"
                  value="true"
                  required
                />
                <span class="checkmark"></span>
                <label
                  class="label_subscribe_newsletter"
                  for="label_subscribe_newsletter"
                  >{{ strings.subscribe_newsletter }}</label
                >
              </div>

              <!-- t&c -->
              <div class="gdpr_wrapper gdpr_wrapper--black">
                <input
                  type="checkbox"
                  id="label_accept_tc_1"
                  name="label_accept_tc_1"
                  value="Accept T&C"
                  required
                />
                <span class="checkmark"></span>
                <label class="label_accept_tc_1" for="label_accept_tc_1">{{
                  strings.programeaza_intalnire_accept_termeni
                }}</label>
              </div>
              <input
                type="submit"
                :value="strings.programeaza_intalnire_accept_trimite"
              />
            </form>
            <h6 class="newsletter-thanks">
              {{ strings.etape_newsletter_thanks }}
            </h6>
          </div>
        </div>

        <!-- slide fainari -->
        <div class="timeline-project-slide">
          <h4 class="timeline-project-title">Făinari</h4>

          <!-- project stats block -->
          <div
            class="project-details-block project-details-block--row our-projects-block"
          >
            <!-- item -->
            <div class="project-details-block-item">
              <svg
                width="133"
                height="88"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  width="125.765"
                  height="45.1551"
                  rx="22.4908"
                  transform="matrix(.99289 .11906 -.16479 .98633 7.441 15)"
                  fill="#F9DF41"
                />
                <path
                  d="M24 38.3333L61.7391 1H108M24 38.3333h46.6667m-46.6667 0v8.9276h14.2029c4.058 0 5.4496 8.5455 5.2754 14.6087-.1615 5.6184 0 13.3913-5.2754 13.3913H24v10.1449h46.6667V75.2609H58.087c-4.4638 0-6.087-2.8406-6.087-13.3913 0-9.7662.8116-14.6087 6.087-14.6087h12.5797m0-8.9276L108 1M70.6667 38.3333v8.9276M108 1v8.9275L70.6667 47.261"
                  stroke="#000"
                  stroke-width="1.6232"
                />
                <path
                  d="M108 36.3046L70.6665 76.0727v9.3333L108 46.0437v-9.7391zM24 75.2611L43.0725 55.377M108 35.8988h-9.3336c-3.6519 0-10.4698.3246-8.5219-8.116M60.522 63.8988c.9739-.3247 19.884-19.343 29.2174-28.8116"
                  stroke="#000"
                  stroke-width="1.6232"
                />
              </svg>
              <h6>
                <span
                  >{{ this.content.fainari.phaseItems["steel"] }} <br />Tone
                  otel</span
                >
              </h6>
            </div>
            <!-- item -->
            <div class="project-details-block-item">
              <svg
                width="133"
                height="84"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  width="125.765"
                  height="45.1551"
                  rx="22.4908"
                  transform="matrix(.99289 .11906 -.16479 .98633 7.441 10)"
                  fill="#F9DF41"
                />
                <path
                  d="M20.3142 25.262l-.0019-.0023-3.8188-4.4397-.0001-.0001-1.4517-1.6886a.0385.0385 0 00-.0019-.0023c-.3054-.3632-.3436-.8577-.1291-1.2235l.0028-.005 9.5447-16.5364.0011-.0018c.2213-.3761.6757-.5838 1.1242-.5024l.0011.0002 31.7378 5.894.0021.0003c1.5275.2924 2.967.831 4.3202 1.5978a.7623.7623 0 01.0039.0022l9.8013 5.6996.0054.0031c3.3538 1.9171 6.0257 4.8613 7.6238 8.3768l.0001.0003 4.4865 9.8578h-.0001l.0057.0121c.1044.2201.1119.5093-.0067.7721l-.0191.0423-.0143.044a2.4505 2.4505 0 00-.0122.0387l-.0048.0155-.0041.0131-.0043.0139-3.4588 5.9876-.0002.0004-5.7284 9.9296-.0004.0006-2.2625 3.9298-.0021.0035c-.172.2884-.4672.4797-.7897.5134h-.0758l-.0411.004-10.6849 1.049c-.6184.0484-1.2287.0927-1.8079.0929-3.2711-.0237-6.4661-.8699-9.2686-2.5102l-.0047-.0027-9.8093-5.6566-.0053-.003c-1.3452-.7628-2.5339-1.7488-3.5447-2.9395l-.0017-.0021-6.1582-7.208-.0005-.0005-3.8184-4.4626-.0005-.0006-5.7279-6.7067z"
                  stroke="#000"
                  stroke-width="1.6848"
                />
                <path
                  d="M9.26 73.1507c-.2014-.2816-.254-.6448-.149-.9623.0002-.0003.0003-.0005.0003-.0008l.4294-1.2871v-.0002l3.3865-10.1604.0012-.0033c.1458-.4189.5631-.7171 1.0167-.7171H16.6969V29.511l11.6814 13.6509v16.8576h27.0699c.3355.0385.9014.054 1.5156.0602.6756.0067 1.4732.0022 2.2334-.0067a229.795 229.795 0 002.6699-.0479l.1785-.0043.047-.0011.0053-.0002h9.9734v-.9707c1.9833-.2659 3.7252-1.4681 4.731-3.1948l.0018-.0032 6.9486-12.0489v16.2176h5.5038V38.173c0-.5852.4822-1.067 1.067-1.067h10.6715c1.724.0894 3.359.7696 4.637 1.9564l14.612 14.9234a.0662.0662 0 01.003.0025c1.089 1.1319 1.695 2.6399 1.695 4.1865v10.5496a7.695 7.695 0 01-.191 1.7117c-.521 2.047-2.493 3.4179-4.6 3.1796l-.047-.0053h-4.709v.8424c0 4.8091-3.895 8.7049-8.705 8.7049-4.8102 0-8.7051-3.8958-8.7051-8.7049v-.8424H58.9297v.8424c0 4.8091-3.8949 8.7049-8.7049 8.7049-4.8099 0-8.7049-3.8958-8.7049-8.7049v-.8424h-5.5037v.8424c0 4.8091-3.895 8.7049-8.7049 8.7049-4.81 0-8.7049-3.8958-8.7049-8.7049v-.8424h-8.4803c-.3353 0-.6578-.1678-.8657-.4591l-.0005-.0006z"
                  stroke="#000"
                  stroke-width="1.6848"
                />
              </svg>
              <h6>
                <span
                  >{{ this.content.fainari.phaseItems["concrete"] }} m3<br />{{
                    strings.toneotel
                  }}</span
                >
              </h6>
            </div>
            <!-- item -->
            <div class="project-details-block-item">
              <svg
                width="134"
                height="86"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  width="125.765"
                  height="45.1552"
                  rx="22.4909"
                  transform="matrix(.99289 .11906 -.16479 .98633 8.2852 14)"
                  fill="#F9DF41"
                />
                <path
                  d="M47.3685 3.7779c-6.7658 6.2454 1.0843 18.2157 5.8551 23.4201 9.3681-8.8477 11.0593-16.264 9.1076-20.8179-1.3011-3.0361-8.1969-8.8476-14.9627-2.6022z"
                  stroke="#000"
                  stroke-width="1.7678"
                />
                <circle
                  cx="54.1918"
                  cy="10.4576"
                  r="4.3206"
                  stroke="#000"
                  stroke-width="1.7678"
                />
                <path
                  d="M59.7896 27.582h23.1196c7.8577 0 14.2275 6.3699 14.2275 14.2275v0c0 7.8576-6.3698 14.2275-14.2275 14.2275H59.7896M84.645 56.037H25.9999c-7.8576 0-14.2274 6.3699-14.2274 14.2275v0c0 7.8576 6.3698 14.2275 14.2274 14.2275h74.0261"
                  stroke="#000"
                  stroke-width="2.1266"
                />
                <path
                  d="M102.152 85V72.2405m0 0V55.2278l18.076 8.5064-18.076 8.5063z"
                  stroke="#000"
                  stroke-width="2.0185"
                />
              </svg>
              <h6>
                <span
                  >{{ this.content.fainari.phaseItems["finish"] }}
                  {{ strings.months }}<br />{{ strings.tofinish }}</span
                >
              </h6>
            </div>
          </div>

          <!-- timeline -->
          <div class="timeline-horizontal">
            <span class="timeline-horizontal-sectiontitle">{{
              strings.evolutie_in_timp
            }}</span>

            <div class="timeline-horizontal-wrapper">
              <ol class="timeline-horizontal--bar">
                <!-- first item -->
                <li
                  class="timeline-horizontal--item"
                  data-list-index="0"
                  :class="stages.fainari[0].status"
                >
                  <span
                    ><strong>start</strong><br />{{
                      stages.fainari[0].dateShort
                    }}</span
                  >
                  <span>{{ stages.fainari[0].title }}</span>
                </li>

                <!-- loop items -->
                <li
                  class="timeline-horizontal--item"
                  v-for="(item, index) in stagesLoop.fainari"
                  :key="index"
                  :class="item.status"
                  :data-list-index="item.listIndex"
                  @click="openSelected(item.listIndex, item.status)"
                >
                  <span
                    ><strong>{{ item.percentage }}%</strong></span
                  >
                  <span class="hideondesktop cta-search-icon"
                    ><svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 511.999 511.999"
                    >
                      <path
                        d="M508.874 478.708L360.142 329.976c28.21-34.827 45.191-79.103 45.191-127.309C405.333 90.917 314.416 0 202.666 0S0 90.917 0 202.667s90.917 202.667 202.667 202.667c48.206 0 92.482-16.982 127.309-45.191l148.732 148.732c4.167 4.165 10.919 4.165 15.086 0l15.081-15.082c4.165-4.166 4.165-10.92-.001-15.085zM202.667 362.667c-88.229 0-160-71.771-160-160s71.771-160 160-160 160 71.771 160 160-71.771 160-160 160z"
                      /></svg
                  ></span>
                  <span class="hideonmobile underbartitle">{{
                    item.title
                  }}</span>

                  <span class="hideondesktop">
                    <svg
                      viewBox="0 0 24 24"
                      class="icon project-icon shape-codepen"
                    >
                      <use
                        :xlink:href="
                          require('@/assets/sprite-sheet.svg') + '#' + item.icon
                        "
                      ></use>
                    </svg>
                  </span>
                </li>

                <!-- final item -->
                <li
                  class="timeline-horizontal--item"
                  data-list-index="last"
                  :class="stages.fainari[this.stages.fainari.length - 1].status"
                  @click="openSelected(last)"
                >
                  <span
                    ><strong>{{ strings.finalizare }}</strong
                    ><br />{{
                      stages.fainari[this.stages.fainari.length - 1].dateShort
                    }}</span
                  >
                  <span>{{
                    stages.fainari[this.stages.fainari.length - 1].title
                  }}</span>
                </li>
              </ol>
            </div>

            <div class="timeline-vertical-wrapper">
              <div class="timeline-vertical-actions">
                <span @click="toggleAll(true)">{{
                  strings.deschide_toate
                }}</span>
                /
                <span @click="toggleAll(false)">{{
                  strings.inchide_toate
                }}</span>
              </div>
              <ol class="timeline-vertical">
                <li
                  class="timeline-vertical--item"
                  v-for="(item, index) in stages.fainari"
                  :key="index"
                  :class="item.status"
                  :data-list-index="item.listIndex"
                  @click="
                    item.slug !== 'autorizatie-de-construire' ||
                    item.slug !== 'building-permit'
                      ? toggleEvent($event, null, item.status)
                      : null
                  "
                >
                  <div class="timeline-vertical--item-row">
                    <span class="timeline-vertical--item-icon">
                      <svg viewBox="0 0 24 24" class="icon shape-codepen">
                        <use
                          :xlink:href="
                            require('@/assets/sprite-sheet.svg') +
                              '#' +
                              item.icon
                          "
                        ></use>
                      </svg>
                    </span>
                    <!-- desktop -->
                    <span class="timeline-vertical--item-title hideonmobile">{{
                      item.title
                    }}</span>
                    <span class="timeline-vertical--item-date hideonmobile"
                      >{{ strings.date }}:
                      <span
                        v-if="
                          item.status === 'Finalizat' || item.status === 'Done'
                        "
                        >{{ item.date }}</span
                      ></span
                    >
                    <span class="timeline-vertical--item-status hideonmobile"
                      >Status:
                      <span
                        class="accent"
                        v-if="
                          item.status !== 'Inchis' && item.status !== 'Closed'
                        "
                        >{{ item.status }}</span
                      ></span
                    >

                    <!-- mobile -->
                    <span class="timeline-vertical--item--mobilewrap">
                      <span class="timeline-vertical--item-title">{{
                        item.title
                      }}</span>
                      <span class="timeline-vertical--item-date"
                        >{{ strings.date }}:
                        <span
                          v-if="
                            item.status !== 'Inchis' && item.status !== 'Closed'
                          "
                          >{{ item.date }}</span
                        ></span
                      >
                      <span class="timeline-vertical--item-status"
                        >Status:
                        <span
                          class="accent"
                          v-if="
                            item.status !== 'Inchis' && item.status !== 'Closed'
                          "
                          >{{ item.status }}</span
                        ></span
                      >
                    </span>
                    <span v-if="item.media.length > 0" class="timeline-vertical--item-iconToggle"
                      ><svg
                        v-if="
                          item.slug !== 'autorizatie-de-construire' ||
                            item.slug !== 'building-permit'
                        "
                        width="16"
                        height="36"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.2929 35.7071c.3905.3905 1.0237.3905 1.4142 0l6.364-6.364c.3905-.3905.3905-1.0236 0-1.4142-.3906-.3905-1.0237-.3905-1.4142 0L8 33.5858l-5.6569-5.6569c-.3905-.3905-1.0237-.3905-1.4142 0-.3905.3906-.3905 1.0237 0 1.4142l6.364 6.364zM7 0v35h2V0H7z"
                          fill="#000"
                        /></svg
                    ></span>
                  </div>
                  <div class="timeline-vertical--item-gallery">
                    <img
                      v-if="
                        (item.status === 'Finalizat' ||
                          item.status === 'Done') &&
                          item.slug !== 'autorizatie-de-construire' &&
                          item.slug !== 'building-permit' &&
                          item.media.img_1 !== null
                      "
                      v-bind:src="item.media.img_1"
                      alt=""
                    />
                    <img
                      v-if="
                        (item.status === 'Finalizat' ||
                          item.status === 'Done') &&
                          item.slug !== 'autorizatie-de-construire' &&
                          item.slug !== 'building-permit' &&
                          item.media.img_2 !== null
                      "
                      v-bind:src="item.media.img_2"
                      alt=""
                    />
                    <img
                      v-if="
                        (item.status === 'Finalizat' ||
                          item.status === 'Done') &&
                          item.slug !== 'autorizatie-de-construire' &&
                          item.slug !== 'building-permit' &&
                          item.media.img_3 !== null
                      "
                      v-bind:src="item.media.img_3"
                      alt=""
                    />
                  </div>
                </li>
              </ol>
            </div>
          </div>

          <!-- form -->
          <div class="timeline-form">
            <h4 class="timeline-project-title">
              {{ strings.evolutie_nl_h4 }}
            </h4>
            <h5 class="timeline-project-subtitle">
              {{ strings.evolutie_nl_h5 }}
            </h5>
            <!-- form -->
            <form
              class="form-styles form-styles--dark form-styles--w70"
              @submit="submitForm"
              action="#"
              method="post"
            >
              <input
                type="hidden"
                id="form_type"
                name="form_type"
                value="phase"
              />
              <input
                type="text"
                v-model="user_name"
                name="user_name"
                value=""
                :placeholder="strings.programeaza_intalnire_nume"
              />
              <input
                type="email"
                v-model="user_email"
                name="email"
                value=""
                :placeholder="strings.programeaza_intalnire_email"
              />
              <input
                type="tel"
                v-model="user_phone"
                pattern="[0-9]{4}[0-9]{3}[0-9]{3}"
                name="tel"
                value=""
                :placeholder="strings.programeaza_intalnire_tel"
              />
              <!-- newsletter -->
              <div class="gdpr_wrapper gdpr_wrapper--black">
                <input
                  type="checkbox"
                  id="label_subscribe_newsletter"
                  name="label_subscribe_newsletter"
                  value="true"
                  required
                />
                <span class="checkmark"></span>
                <label
                  class="label_subscribe_newsletter"
                  for="label_subscribe_newsletter"
                  >{{ strings.subscribe_newsletter }}</label
                >
              </div>

              <!-- t&c -->
              <div class="gdpr_wrapper gdpr_wrapper--black">
                <input
                  type="checkbox"
                  id="label_accept_tc_1"
                  name="label_accept_tc_1"
                  value="Accept T&C"
                  required
                />
                <span class="checkmark"></span>
                <label class="label_accept_tc_1" for="label_accept_tc_1">{{
                  strings.programeaza_intalnire_accept_termeni
                }}</label>
              </div>
              <input
                type="submit"
                :value="strings.programeaza_intalnire_accept_trimite"
              />
            </form>
            <h6 class="newsletter-thanks">
              {{ strings.etape_newsletter_thanks }}
            </h6>
          </div>
        </div>
        <!-- / slide fainari -->
      </div>
      <!-- slide -->
    </div>

    <!-- Map -->
    <div class="section-wrapper" style="margin-top: 80px;z-index:80;">
      <div class="project-details-shadow our-projects-shadow mask-left active">
        <h2 class="poz-proiecte">
          {{ strings.pozitionare_proiecte_map_title }}
        </h2>
      </div>
    </div>
    <div class="project-map2" ref="mapcontainer"></div>

    <!-- footer social -->
    <div class="social-footer">
      <div class="social-footer-wrapper">
        <div class="social-footer-network">
          <a href="#" class="icon fb">
            <svg
              width="64"
              height="34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                width="59.2"
                height="24.9"
                rx="12.5"
                transform="rotate(8.1 .2 31.5)"
                fill="#F9DF41"
              />
              <path
                d="M28 32.5h6.5V16.3H39l.4-5.5h-4.9v-3c0-1.4.3-2 1.6-2h3.5V.4H35c-4.8 0-7 2-7 6.1v4.4h-3.4v5.5h3.4v16.2H28z"
                fill="#222221"
              />
            </svg>
          </a>
          <a href="#" class="icon ig"
            ><svg
              width="63"
              height="34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                width="59.2"
                height="24.9"
                rx="12.5"
                transform="rotate(8.1 0 27.5)"
                fill="#F9DF41"
              />
              <path
                d="M31.2 5.7c4 0 4.3 0 5.9.2a5 5 0 012.6.5c.7.3 1.1.6 1.7 1.2.6.5.8 1 1.1 1.6.2.6.4 1.3.6 2.7l.1 5.9-.1 5.9a5 5 0 01-.6 2.6c-.3.7-.5 1.2-1 1.7-.7.6-1 .9-1.8 1.1-.5.2-1.2.5-2.6.6l-6 .1-5.8-.1a5 5 0 01-2.7-.6c-.7-.2-1-.5-1.6-1-.6-.6-.9-1-1.2-1.8-.1-.5-.4-1.2-.5-2.6-.2-1.6-.2-2-.2-6 0-3.8 0-4.3.2-5.8a5 5 0 01.5-2.7c.3-.7.6-1 1.2-1.6.5-.6 1-.9 1.6-1.2.6-.1 1.3-.4 2.7-.5 1.4-.2 2-.2 5.9-.2zm0-2.6l-6 .1c-1.6.2-2.7.3-3.5.7-1 .4-1.9.9-2.6 1.7-.8.8-1.2 1.7-1.6 2.5-.5 1-.6 2-.7 3.5-.2 1.6-.2 2.1-.2 6 0 4 0 4.5.2 6 0 1.6.2 2.7.7 3.6.4 1 .8 1.8 1.6 2.5.9.8 1.7 1.3 2.6 1.7 1 .4 2 .5 3.5.7l6 .1 6-.1c1.5-.2 2.7-.3 3.5-.7 1-.4 1.8-.9 2.5-1.7.9-.8 1.3-1.7 1.7-2.5.4-1 .6-2 .7-3.5.2-1.6.2-2.1.2-6 0-4 0-4.5-.2-6C45.5 10 45.3 9 45 8c-.4-1-.8-1.8-1.7-2.5a8.8 8.8 0 00-2.5-1.7c-1-.4-2-.5-3.5-.7l-6-.1z"
                fill="#222221"
              />
              <path
                d="M31.2 10.2a7.5 7.5 0 00-7.6 7.6c0 4.2 3.4 7.6 7.6 7.6 4.2 0 7.5-3.4 7.5-7.6a7.7 7.7 0 00-7.5-7.6zm0 12.5a5 5 0 01-5-5 5 5 0 015-4.8 5 5 0 014.9 4.9c-.2 2.7-2.3 4.9-5 4.9zM40.7 10c0 1-.8 1.8-1.8 1.8S37 10.9 37 9.9c0-1 .8-1.8 1.8-1.8 1 .2 1.8.9 1.8 1.8z"
                fill="#222221"
              /></svg
          ></a>
          <a href="#" class="icon in">
            <svg
              width="63"
              height="34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                width="59.2"
                height="24.9"
                rx="12.5"
                transform="rotate(8.1 .2 30.7)"
                fill="#F9DF41"
              />
              <path fill="#000" d="M14.9 10.2h7.4v22.7h-7.4z" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M33.9 19.7c.5-1.6 2-3.7 4.4-3.7 2.3 0 3.5 2.3 3.5 3.4h7.4c0-1.9-.5-6-4-8.3-1.4-1-5.3-2.3-8.8 0-.8.6-1.8 1.7-2.5 3v-4h-7.4V33h7.4V19.7zm7.9-.3h7.4V33h-7.4V19.4z"
                fill="#000"
              />
              <ellipse cx="18.9" cy="3.7" rx="3.9" ry="3.7" fill="#000" />
            </svg>
          </a>
        </div>
        <span
          ><router-link v-bind:to="'/privacypolicy'"
            >Politică de Confidențialitate</router-link
          ></span
        >
        <span>Rise Ap.Art 2020. All right reserved.</span>
      </div>
      <!-- scroll to top -->
      <div class="scroll-to-top">
        <a href="#" @click.prevent="scrollTo('.timeline-header')">
          <svg
            width="24"
            height="34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13 1c-.5-.6-1.5-.6-2 0l-9.6 9.5a1.5 1.5 0 102.1 2.1L12 4.1l8.5 8.5a1.5 1.5 0 102.1-2.1L13.1.9zm.5 33V2h-3v32h3z"
              fill="#000"
            />
          </svg>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from "axios";
import gmapsInit from "../utils/gmaps";
import router from "../router";
import { bus } from "../main";
import axios from "axios";
import dateFormat from "dateformat";

export default {
  name: "PrivacyPolicy",
  components: {},
  data() {
    return {
      locale: "",
      content: {
        precupeti: {
          phaseImtes: []
        },
        fainari: {
          phaseImtes: []
        },
        phaseItems: []
      },
      strings: {
        home_proiectele_noastre: "",
        programeaza_intalnire_cta: "",
        programeaza_intalnire_headline: "",
        programeaza_intalnire_thanks: "",
        contact_titlu: "",
        footer_titlu: "",
        footer_text: "",
        footer_form_title: "",
        programeaza_intalnire_accept_trimite: "",
        all_rights_reserved: "",
        vezi_harta: "",
        ask_us_thankyou: "",
        prin_telefon: "",
        prin_email: "",
        evolutie_h2: "",
        evolutie_h3: "",
        toneotel: "",
        concrete: "",
        months: "",
        tofinish: "",
        evolutie_in_timp: "",
        finalizare: "",
        deschide_toate: "",
        inchide_toate: "",
        date: "",
        evolutie_nl_h4: "",
        evolutie_nl_h5: "",
        pozitionare_proiecte_map_title: ""
      },
      stagesLoop: {
        precupeti: [],
        fainari: []
      },
      stages: {
        precupeti: [],
        fainari: []
      },
      phasesCount: "",
      form_type: "",
      user_name: "",
      user_email: "",
      user_phone: "",
      user_message: "",
      fbUrl: "",
      igUrl: "",
      liUrl: ""
    };
  },
  methods: {
    fetchData: function() {
      var self = this;

      // console.log("locale is: " + self.locale);
      // reset strings
      self.strings.programeaza_intalnire_cta = "";
      self.strings.programeaza_intalnire_headline = "";
      self.strings.programeaza_intalnire_thanks = "";
      self.strings.pozitionare_proiecte_map_title = "";
      self.strings.all_rights_reserved = "";

      // content
      axios
        .get("https://api.riseapart.com/project", {
          headers: {
            "X-Locale": self.locale
          }
        })
        .then(function(data) {
          // console.log(data);

          self.content.precupeti = data.data.data[0];
          const phases = data.data.data[0].phases.data;
          self.phasesCount = phases.length;

          // console.log(phases);

          for (let x = 0; x < phases.length; x++) {
            let percentage = ((x + 1) * 100) / phases.length;

            self.stages.precupeti.push({
              title: phases[x].title,
              date: dateFormat(phases[x].date, "dd-mm-yyyy"),
              dateShort: dateFormat(phases[x].date, "mm-yyyy"),
              status: phases[x].status,
              percentage: parseInt(percentage),
              slug: phases[x].slug,
              icon: phases[x].icon,
              media: phases[x].mediaFiles,
              listIndex: x
            });
          }

          // console.log(self.stages.precupeti);
          // console.log(self.content.precupeti);

          // fainari

          self.content.fainari = data.data.data[2];
          const phasesFainari = data.data.data[2].phases.data;
          self.phasesCount = phasesFainari.length;

          // console.log(phasesFainari);

          for (let y = 0; y < phasesFainari.length; y++) {
            let percentage = ((y + 1) * 100) / phasesFainari.length;

            self.stages.fainari.push({
              title: phasesFainari[y].title,
              date: dateFormat(phasesFainari[y].date, "dd-mm-yyyy"),
              dateShort: dateFormat(phasesFainari[y].date, "mm-yyyy"),
              status: phasesFainari[y].status,
              percentage: parseInt(percentage),
              slug: phasesFainari[y].slug,
              icon: phasesFainari[y].icon,
              media: phasesFainari[y].mediaFiles,
              listIndex: y
            });
          }

          // console.log(self.stages.fainari);
          // console.log(self.content.fainari);

          //
          self.setLoopStages();

          //
          self.initMaps();
        })
        .catch(function(error) {
          console.log("Error", error);
        });

      // get translatable strings
      axios
        .get("https://api.riseapart.com/content?_limit=100", {
          headers: { "X-Locale": self.locale }
        })
        .then(function(data) {
          let stringsObj = data.data.data;
          let x;

          // get all strings
          for (x = 0; x < stringsObj.length; x++) {
            let newObj = stringsObj[x];
            let newKey = Object.keys(newObj);
            self.strings[newObj[newKey].key] = newObj[newKey].value;
          }

          // console.log("the strings are:", self.strings);
        })
        .catch(function(error) {
          console.log("Error", error);
        });

      // get settings (social urls)
      axios
        .get("https://api.riseapart.com/configuration")
        .then(function(res) {
          var facebookUrl = res.data.data.filter(obj => {
            return obj.key === "FACEBOOK_URL";
          });

          var instagramUrl = res.data.data.filter(obj => {
            return obj.key === "INSTAGRAM_URL";
          });

          var linkedinUrl = res.data.data.filter(obj => {
            return obj.key === "LINKEDIN_URL";
          });

          self.fbUrl = facebookUrl[0].defaultValue;
          self.igUrl = instagramUrl[0].defaultValue;
          self.liUrl = linkedinUrl[0].defaultValue;
        })
        .catch(function(error) {
          console.log("Error", error);
        });
    },
    setLoopStages: function() {
      // this.stagesLoop

      for (var x = 1; x < this.stages.precupeti.length - 1; x++) {
        this.stagesLoop.precupeti.push(this.stages.precupeti[x]);
      }

      console.log("stages: ", this.stagesLoop);

      for (var y = 1; y < this.stages.fainari.length - 1; y++) {
        this.stagesLoop.fainari.push(this.stages.fainari[y]);
      }
    },
    submitForm(e) {
      e.preventDefault();

      // console.log(e);
      var form = e.srcElement;
      var form_type = form.querySelector("#form_type").value;

      let bodyFormData = new FormData();
      if (
        parseInt(
          document
            .querySelector(".timeline-controller")
            .getAttribute("data-index")
        ) === 0
      ) {
        bodyFormData.set("project", this.content.precupeti.id);
      } else {
        bodyFormData.set("project", this.content.fainari.id);
      }
      bodyFormData.set("type", form_type);
      bodyFormData.set("email", this.user_email);
      bodyFormData.set("name", this.user_name);
      bodyFormData.set("phone", this.user_phone);
      bodyFormData.set("tos", "true");

      // set loading animation on button
      form.querySelector('input[type="submit"]').classList.add("loading");

      if (
        document.querySelector("#label_subscribe_newsletter") ||
        document.querySelector("#label_subscribe_newsletter").checked
      ) {
        bodyFormData.set("news", true);
      }

      axios({
        method: "post",
        url: "https://api.riseapart.com/send-form",
        data: bodyFormData,
        headers: { "Content-Type": "multipart/form-data" }
      })
        .then(function(response) {
          // stop loading animation
          form
            .querySelector('input[type="submit"]')
            .classList.remove("loading");

          // handle success
          // phase
          if (response.data.data.confirmation === 1 && form_type === "phase") {
            // thank you message=
            // document.querySelector(".newsletter-thanks").style.display = "block";
            form.querySelector('input[type="submit"]').style.display = "none";
            form.nextSibling.style.display = "block";
          }
        })
        .catch(function(response) {
          // stop loading animation
          form
            .querySelector('input[type="submit"]')
            .classList.remove("loading");

          //handle error
          // console.log("error: " + response);

          if (response.name) {
            form
              .querySelector("input[name='user_name']")
              .classList.add("error");
          }

          if (response.email) {
            form
              .querySelector("input[name='user_email']")
              .classList.add("error");
          }

          if (response.phone) {
            form
              .querySelector("input[name='user_phone']")
              .classList.add("error");
          }
        });
    },
    scrollTo(el) {
      // document.querySelector(el).scrollIntoView({
      //   behavior: "smooth"
      // });
      const yOffset = -180;
      const element = document.querySelector(el);
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({ top: y, behavior: "smooth" });
    },
    openSelected(index, status) {
      var domEl = '.timeline-vertical--item[data-list-index="' + index + '"]';
      var el = document.querySelector(domEl);
      // check if it has images
      // console.log(!!el.querySelector("img"));

      // toggle phase view
      if (el.querySelector("img")) {
        this.toggleEvent(null, el, status);
      }

      // put the active phase in view
      this.scrollTo(domEl);
    },
    toggleEvent(event, fromDataIndex, status) {
      // console.log(event);
      var elIndex =
        event !== null
          ? event.target
              .closest(".timeline-vertical--item")
              .getAttribute("data-list-index")
          : null;

      if (
        (status === "Finalizat" || status === "Done") &&
        (elIndex === null || elIndex > 0)
      ) {
        if (event) {
          event.preventDefault();
          var el = event.target.closest(".timeline-vertical--item");
        } else {
          el = fromDataIndex;
        }

        
        // check if imgs
        if (el.querySelector('.timeline-vertical--item-gallery img')) {
          if (el.classList.contains("active")) {
            el.classList.remove("active");
          } else {
            el.classList.add("active");
          }
        }
        
      }
    },
    toggleAll(bool) {
      var divs = document.querySelectorAll(
        ".timeline-vertical--item.Finalizat:not(:first-child)"
      );
      if (bool) {
        [].forEach.call(divs, function(div) {
          // do whatever
          div.classList.add("active");
        });
      } else {
        [].forEach.call(divs, function(div) {
          // do whatever
          div.classList.remove("active");
        });
      }
    },
    controlWrapper(direction) {
      const wrapper = document.querySelector(".timeline-wrapper");
      const wrapperIndex = parseInt(wrapper.getAttribute("data-index"));
      const controller = document.querySelector(".timeline-controller");
      // const controllerIndex = parseInt(controller.getAttribute("data-index"));

      if (direction === "prev" && wrapperIndex > 0) {
        wrapper.setAttribute("data-index", wrapperIndex - 1);
        controller.setAttribute("data-index", wrapperIndex - 1);
      }

      if (direction === "next" && wrapperIndex < 1) {
        wrapper.setAttribute("data-index", wrapperIndex + 1);
        controller.setAttribute("data-index", wrapperIndex + 1);
      }
    },
    StickyForm(bool) {
      const el = document.querySelector(".sticky-form");
      if (bool) {
        el.classList.add("visible");
      } else {
        el.classList.remove("visible");
      }
    },
    setProjectSlide() {
      document
        .querySelector(".timeline-project.timeline-wrapper")
        .scrollIntoView({
          behavior: "smooth"
        });

      if (this.$route.query.project == "fainari") {
        document
          .querySelector(".timeline-project.timeline-wrapper")
          .setAttribute("data-index", 1);
        document
          .querySelector(".timeline-controller")
          .setAttribute("data-index", 1);
      }
    },
    async initMaps() {
      // gmaps
      try {
        const google = await gmapsInit();
        const precupeti = { lat: 44.44769, lng: 26.11796 };
        const ronda = { lat: 44.43691, lng: 26.12572 };
        const fainari = { lat: 44.44866, lng: 26.12109 };
        const center = { lat: 44.444722, lng: 26.120497 };

        //
        var map = new google.maps.Map(document.querySelector(".project-map2"), {
          center: center,
          zoom: 15,
          styles: [
            {
              elementType: "geometry",
              stylers: [
                {
                  color: "#f5f5f5"
                }
              ]
            },
            {
              elementType: "labels.icon",
              stylers: [
                {
                  visibility: "off"
                }
              ]
            },
            {
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#616161"
                }
              ]
            },
            {
              elementType: "labels.text.stroke",
              stylers: [
                {
                  color: "#f5f5f5"
                }
              ]
            },
            {
              featureType: "administrative.land_parcel",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#bdbdbd"
                }
              ]
            },
            {
              featureType: "poi",
              elementType: "geometry",
              stylers: [
                {
                  color: "#eeeeee"
                }
              ]
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#757575"
                }
              ]
            },
            {
              featureType: "poi.park",
              elementType: "geometry",
              stylers: [
                {
                  color: "#e5e5e5"
                }
              ]
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#9e9e9e"
                }
              ]
            },
            {
              featureType: "road",
              elementType: "geometry",
              stylers: [
                {
                  color: "#ffffff"
                }
              ]
            },
            {
              featureType: "road.arterial",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#757575"
                }
              ]
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [
                {
                  color: "#dadada"
                }
              ]
            },
            {
              featureType: "road.highway",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#616161"
                }
              ]
            },
            {
              featureType: "road.local",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#9e9e9e"
                }
              ]
            },
            {
              featureType: "transit.line",
              elementType: "geometry",
              stylers: [
                {
                  color: "#e5e5e5"
                }
              ]
            },
            {
              featureType: "transit.station",
              elementType: "geometry",
              stylers: [
                {
                  color: "#eeeeee"
                }
              ]
            },
            {
              featureType: "water",
              elementType: "geometry",
              stylers: [
                {
                  color: "#c9c9c9"
                }
              ]
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#9e9e9e"
                }
              ]
            }
          ]
        });
        // The markers
        var markers = [];

        markers[0] = new google.maps.Marker({
          position: precupeti,
          url: "precupetii-vechi",
          icon: {
            url: require("../assets/precupetii-marker_" + this.locale + ".png"),
            size: new google.maps.Size(117, 168),
            scaledSize: new google.maps.Size(117, 168)
          },
          map: map
        });
        markers[1] = new google.maps.Marker({
          position: ronda,
          url: "ronda",
          icon: {
            url: require("../assets/ronda-marker_" + this.locale + ".png"),
            size: new google.maps.Size(117, 168),
            scaledSize: new google.maps.Size(117, 168)
          },
          map: map
        });
        markers[2] = new google.maps.Marker({
          position: fainari,
          url: "fainari",
          icon: {
            url: require("../assets/fainari-marker_" + this.locale + ".png"),
            size: new google.maps.Size(117, 168),
            scaledSize: new google.maps.Size(117, 168)
          },
          map: map
        });

        // set marker url
        for (var i = 0; i < markers.length; i++) {
          google.maps.event.addListener(markers[i], "click", function() {
            router.push({ path: `/project/${this.url}` });
          });
        }
      } catch (error) {
        console.error(error);
      }
    }
  },
  async mounted() {
    this.initMaps();
  },
  updated: function() {
    this.setProjectSlide();

    const lastestPhase =
      this.locale === "ro"
        ? Array.from(
            document.querySelectorAll(".timeline-horizontal--item.Finalizat")
          ).pop()
        : Array.from(
            document.querySelectorAll(".timeline-horizontal--item.Done")
          ).pop();
    lastestPhase.classList.add("lastchild");
  },
  created() {
    // langCheck
    // console.log(this.$route.query.lang);
    if (!this.$route.query.lang) {
      router.push({ query: { lang: "ro" } });
      this.locale = "ro";
    } else {
      this.locale = this.$route.query.lang;
      this.fetchData();
    }

    // lang switch
    bus.$on("lang", data => {
      this.locale = data.lang;
      this.fetchData();
    });
  },
  beforeCreate: function() {
    document.body.className = "class-project-timeline";
  },
  beforeDestroy() {
    // window.removeEventListener("resize", this.mq);
  }
};
</script>

<style lang="scss">
@import "~@/assets/styles/_reset.scss";
@import "~@/assets/styles/_variables.scss";
@import "~@/assets/styles/_components.scss";
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;600&display=swap");

html {
  scroll-behavior: smooth;
}

.class-project-timeline {
  .vue-fixed-header {
    svg > g > path:nth-child(1) {
      fill: $color-light;
      transition: fill 0.3s ease;
    }
  }

  .vue-fixed-header.vue-fixed-header--isFixed {
    svg > g > path:nth-child(1) {
      fill: $color-yellow;
      transition: fill 0.3s ease;
    }
  }
}

.mask-left {
  -webkit-mask-image: url("~@/assets/mask-left.png");
  mask-image: url("~@/assets/mask-left.png");
  -webkit-mask-position: -20vw -4vh;
  mask-position: -20vw -4vh;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-size: 120vw 100vh;
  mask-size: 120vw 100vh;
  object-fit: cover;
  transition: -webkit-mask-position 1s ease 0.4s;

  &.active {
    -webkit-mask-position: 0 0;
    mask-position: 0 0;
  }

  @media screen and (max-width: 1200px) {
    -webkit-mask-position: 0 0;
    mask-position: 0 0;
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-size: 140vw 90vh;
    mask-size: 140vw 90vh;
    object-fit: cover;
    transition: none;

    &.active {
      -webkit-mask-position: 0 0;
      mask-position: 0 0;
    }
  }

  @media screen and (max-width: 768px) {
    -webkit-mask-position: 0 0;
    mask-position: 0 0;
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-size: 1920px 940px;
    mask-size: 1920px 940px;
    object-fit: cover;
    transition: none;

    &.active {
      -webkit-mask-position: 0 0;
      mask-position: 0 0;
    }
  }
}

.timeline-header-shadow {
  position: relative;
  display: block;
  width: 100vw;
  height: 70vh;
  background-color: $color-yellow;
  z-index: 92;

  &.mask-left {
    -webkit-mask-size: 150vw 70vh;
    mask-size: 150vw 70vh;
  }

  @media screen and (min-width: 1024px) {
    height: 100vh;

    &.mask-left {
      -webkit-mask-size: 1920px 940px;
      mask-size: 1920px 940px;
    }
  }

  .header-title {
    position: absolute;
    top: 25%;
    right: 0;
    left: 0;

    @media screen and (min-width: 1024px) {
      top: 30%;
    }
  }

  h2 {
    position: relative;
    max-width: 76vw;
    margin: 0 auto;
    font-family: "Poppins", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 30px;
    line-height: 120%;
    letter-spacing: -0.015em;
    text-transform: none;
    color: $color-dark;

    @media screen and (min-width: 1024px) {
      font-size: 66px;
    }
  }

  h3 {
    position: relative;
    max-width: 60vw;
    margin: 40px auto 0;
    font-family: "Poppins", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 120%;
    letter-spacing: -0.015em;
    text-transform: none;
    color: $color-dark;
    text-align: center;

    @media screen and (min-width: 1024px) {
      font-size: 30px;
      max-width: 76vw;
    }
  }
}

.timeline {
  .hideonmobile {
    @media screen and (max-width: 1023px) {
      display: none;
    }
  }

  .hideondesktop {
    @media screen and (min-width: 1024px) {
      display: none;
    }
  }

  .project-details {
    display: block;
    width: 100vw;
    height: 100vh;
    margin-top: 30px;
    margin-left: 0;
    background-size: cover;
    background-position: center center;
    background-repeat: none;
    background-color: $color-light;
    text-align: center;
    transition: opacity 0.3s ease, -webkit-mask-position 1s ease;

    &-shadow {
      display: block;
      width: 100vw;
      height: 100vh;
      background-color: $color-dark;
    }

    &-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      max-width: calc(1200px - 100px);
      height: 100%;
      max-height: 620px;
      margin: 120px auto 0;
    }

    &-block {
      display: flex;
      flex-direction: column;
      align-items: center;

      &--row {
        width: 80%;
        margin: 80px auto 0;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-end;

        @media screen and (max-width: 760px) {
          width: 100%;
          margin: 20px auto 0;
        }
      }

      &-title {
        display: block;
      }

      .v-spacer {
        display: block;
        width: 2px;
        height: 25px;
        margin: 25px auto;
        background: $color-dark;

        @media screen and (max-width: 760px) {
          height: 16px;
          margin: 16px auto;
        }
      }

      @media screen and (max-width: 760px) {
        flex-wrap: nowrap;

        &-item {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;
          width: 33%;

          &:last-child {
            margin-top: 20px;
            margin-right: auto;
          }

          svg {
            transform: scale(0.4);
          }
        }
      }

      h5,
      h6 {
        display: block;
        font-family: "Poppins", sans-serif;
        font-style: normal;
        color: $color-dark;
        text-align: center;
      }

      h5 {
        font-weight: normal;
        font-size: 18px;
        line-height: 27px;
        letter-spacing: 0.2em;
        text-transform: uppercase;
        color: $color-dark;

        @media screen and (max-width: 760px) {
          font-size: 12px;
        }
      }

      h6 {
        font-weight: 300;
        font-size: 20px;
        line-height: 28px;

        @media screen and (max-width: 760px) {
          margin: 0;
          font-size: 12px;
          line-height: 16px;
        }

        span {
          &:first-child {
            display: inline-block;

            @media screen and (max-width: 760px) {
              margin-top: 10px;
              font-size: 12px;
              line-height: 16px;
            }
          }

          display: block;
        }
      }
    }
  }

  &-header {
    height: 50vh;

    @media screen and (min-width: 1024px) {
      height: 100vh;
    }
  }

  &-controller {
    position: relative;
    display: flex;
    flex-direction: row;
    width: 60vw;
    justify-content: space-between;
    margin: 190px 0 -190px;
    z-index: 200;

    &-next {
      transition: opacity 0.3s ease;

      svg {
        transform: rotate(180deg);
      }

      @media screen and (max-width: 760px) {
        transform: translate(55px, -5px) scale(0.7);
      }
    }

    &-prev {
      transition: opacity 0.3s ease;

      @media screen and (max-width: 760px) {
        transform: translate(-55px, -5px) scale(0.7);
      }
    }

    &[data-index="0"] {
      .timeline-controller-prev {
        opacity: 0.5;
      }
    }

    &[data-index="1"] {
      .timeline-controller-next {
        opacity: 0.5;
      }
    }

    &-next:hover,
    &-prev:hover {
      cursor: pointer;
    }
  }

  &-wrapper {
    width: 200vw;
    display: flex;
    flex-direction: row;
    margin-left: -20vw;
    transform: translate(0, 0px);
    transition: transform 0.3s ease;

    &[data-index="1"] {
      transform: translate(-100vw, 0px);
    }
  }

  &-project-slide {
    width: 70vw;
    margin: 0 15vw;
  }

  &-project {
    &-title {
      display: block;
      margin: 160px auto 0;
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-size: 23px;
      line-height: 23px;
      text-align: center;

      @media screen and (min-width: 1024px) {
        font-size: 38px;
        line-height: 38px;
      }
    }

    &-subtitle {
      display: block;
      margin: 30px auto 50px;
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: 300;
      font-size: 12px;
      line-height: 16px;
      text-align: center;

      @media screen and (min-width: 1024px) {
        font-size: 20px;
        font-weight: 600;
        line-height: 26px;
      }
    }
  }

  &-content {
    display: block;
    width: 80vw;
    // max-width: 960px;
    margin: 0 20vw;

    &-update {
      font-size: 10px;

      @media screen and (min-width: 1024px) {
        font-size: 20px;
      }
    }
  }

  &-horizontal {
    display: block;
    margin-top: 150px;

    @media screen and (max-width: 760px) {
      margin-top: 80px;
    }

    .project-icon {
      display: block;
      width: 25px;
      margin-left: -2px;
    }

    &-sectiontitle {
      display: block;
      margin-bottom: 120px;
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: 300;
      font-size: 16px;
      line-height: 20px;
      text-align: center;
      letter-spacing: 0.2em;
      text-transform: uppercase;
      color: $color-dark;

      @media screen and (min-width: 1024px) {
        font-size: 20px;
        line-height: 30px;
      }
    }

    $stageWidth: 80px;
    $stageWidthMobile: 10px;
    $stageHeightMobile: 30px;

    &-wrapper {
      margin-left: 0;
      width: 100%;

      @media screen and (min-width: 1024px) {
        margin-left: -25px;
      }
    }

    &--bar {
      // display: flex;
      // flex-direction: column;
      // justify-content: space-between;
      // align-items: center;
      // width: 20px;
      // max-width: 20px;
      // height: 100%;
      // margin: 50px auto 0;
      // background-color: $color-lightgrey;

      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      // max-width: calc(#{$stageWidthMobile} * 20);
      max-width: 90vw;
      height: 4px;
      margin: 50px auto 0;
      background-color: $color-grey-timeline;

      &[data-full="true"] {
        background-color: $color-yellow;
      }

      @media screen and (min-width: 1024px) {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        // max-width: calc(#{$stageWidth} * 7);
        height: 9px;
        margin: 50px auto 0;
        background-color: $color-lightgrey;
      }
    }

    &--item {
      position: relative;
      display: block;
      width: 10px;
      height: 10px;
      margin-top: 0;
      border-radius: 10px;
      border: 2px solid $color-yellow;
      background-color: $color-grey-timeline;
      z-index: 900;
      opacity: 0;

      @media screen and (min-width: 1024px) {
        display: block;
        width: 30px;
        height: 30px;
        margin-top: 30px;
        border-radius: 30px;
        margin-top: 0;
        opacity: 1;
      }

      &::after {
        content: "";
        // position: absolute;
        // top: 12px;
        // left: 3px;
        // width: 5px;
        // height: $stageHeightMobile;
        // background-color: $color-grey-timeline;
        // z-index: 10;

        position: absolute;
        top: 1px;
        left: 8px;

        height: 4px;
        background-color: $color-grey-timeline;
        z-index: 10;

        @media screen and (min-width: 1024px) {
          position: absolute;
          top: 9px;
          left: 28px;
          display: block;
          width: $stageWidth;
          height: 9px;
          background-color: $color-grey-timeline;
          z-index: 10;
        }
      }

      &:first-child {
        display: block;
        margin-right: 50px;
        opacity: 1;

        @media screen and (max-width: 768px) {
          margin-right: 20px;
        }

        span {
          width: 150px;

          @media screen and (max-width: 768px) {
            top: -50px !important;
            margin-right: 0;
            text-align: left !important;
          }
        }

        &::after {
          @media screen and (max-width: 768px) {
            width: 10px;
          }
          @media screen and (min-width: 1024px) {
            width: 100px;
            left: 24px;
          }
        }
      }

      &:last-child {
        display: block;
        // top: 20px;
        top: 0;
        left: 0;
        opacity: 1;

        @media screen and (max-width: 768px) {
          margin-left: 20px;
        }

        @media screen and (min-width: 1024px) {
          top: auto;
          left: 50px;
        }

        &::after {
          content: "";
          position: absolute;
          // top: -32px;
          // right: 3px;
          // left: auto;
          // width: 5px;
          // height: 30px;

          position: absolute;
          top: 1px;
          left: 8px;
          right: 0;
          width: 80px;
          height: 4px;

          background-color: $color-light;
          z-index: 10;

          @media screen and (min-width: 1024px) {
            top: 9px;
            right: 28px;
            left: auto;
            width: 50px;
            height: 9px;
            background-color: $color-grey-timeline;
          }
        }

        span:first-child {
          @media screen and (max-width: 768px) {
            // top: 25px;
            left: -73px;
            width: 80px;
            text-align: right !important;
          }
        }
      }

      &:hover {
        cursor: pointer;

        span:last-child {
          opacity: 1;
          transform: translate3d(0, 0, 0);
        }
      }

      &.Finalizat.lastchild,
      &.Done.lastchild {

        @media screen and (max-width: 768px) {
          width: 20px;
          height: 20px;
          border-radius: 20px;
          opacity: 1;
          // margin-right: 120px;

          .cta-search-icon {
            svg {
              display: block;
              width: 10px;
              margin: 2px auto 0;
            }
          }

          &::after {
            top: 6px;
            left: -40px;
            width: 40px;
            z-index: 11;
            background-color: $color-yellow;
            // width: 200px;
            // background-color: $color-grey-timeline !important;
          }

          span:first-child {
            top: 0;
            bottom: auto;
            left: 0;
            margin-top: 40px;
            opacity: 1 !important;

            strong {
              font-weight: normal !important;
            }
          }

          span:last-child {
            top: 0;
            bottom: auto;
            left: 0;
            // width: 100px;
            margin-top: 50px;
            text-align: center;
            opacity: 1;
          }
        }
      }

      &.Finalizat,
      &.Done,
      &.active {
        background-color: $color-yellow;

        &::after {
          background-color: $color-yellow;
        }

        /*&:last-child {
          &::after {
            background-color: $color-grey-timeline;
          }
        }*/
      }

      &:not(:first-child):not(:last-child) {
        span:first-child,
        .underbartitle {
          opacity: 0;
          transform: translate3d(0, -5px, 0);
          transition: all 0.3s ease;
        }

        .underbartitle {
          @media screen and (min-width: 1024px) {
            position: absolute;
            top: 60px;
          }
        }

        &:hover {
          span:first-child,
          .underbartitle {
            opacity: 1;
            transform: translate3d(0, 0, 0);
            transition: all 0.3s ease;
          }
        }
      }

      span {
        font-family: "Poppins", sans-serif;
        font-style: normal;
        font-weight: 300;
        font-size: 12px;
        line-height: 14px;

        @media screen and (min-width: 1024px) {
          font-size: 15px;
          line-height: 15px;
        }
      }

      span:first-child {
        position: absolute;
        top: -50px;
        left: 0;
        text-align: left;
        z-index: 20;
        @media screen and (min-width: 1024px) {
          width: 90px;
        }
      }

      span:last-child {
        position: absolute;
        bottom: -60px;
        left: 0;
        text-align: left;
        // color: $color-lightgreytext;
        opacity: 0;
        transform: translate3d(0, 5px, 0);
        transition: all 0.3s ease;
        z-index: 20;
      }
    }
  }

  &-vertical {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 1000px;
    margin: 0 auto;

    &-actions {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
      margin: 150px auto 30px;

      &:hover {
        cursor: pointer;
      }

      @media screen and (max-width: 768px) {
        justify-content: center;
      }

      span {
        margin: 0 5px;
      }
    }

    &--item {
      width: 100%;
      height: 70px;
      margin-bottom: 5px;
      padding: 0 38px;
      border-radius: 60px;
      background-color: $color-grey-timeline;
      transition: all 0.3s ease;
      overflow: hidden;

      @media screen and (max-width: 768px) {
        padding: 0 18px;
      }

      &:hover {
        cursor: pointer;
      }

      &[data-list-index="0"] {
        .timeline-vertical--item-iconToggle {
          visibility: hidden;
        }
      }

      &-row {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding: 10px 0;

        @media screen and (max-width: 768px) {
          justify-content: flex-start;
          align-items: flex-start;
        }
      }

      &--mobilewrap {
        display: none;

        @media screen and (max-width: 768px) {
          display: flex;
          flex-direction: column;
          width: 75%;

          span {
            width: 100%;
          }
        }
      }

      &-icon {
        width: 10%;

        svg {
          width: 45px;
          margin-top: 3px;
        }

        @media screen and (max-width: 768px) {
          width: 20%;

          svg {
            transform: scale(0.8);
          }
        }
      }

      &-title {
        width: 45%;

        @media screen and (max-width: 768px) {
          font-size: 12px;
          font-weight: 600;
        }
      }

      &-date {
        width: 20%;

        @media screen and (max-width: 768px) {
          font-size: 11px;
        }
      }

      &-status {
        width: 20%;

        @media screen and (max-width: 768px) {
          font-size: 11px;
        }
      }

      &-iconToggle {
        width: 5%;
        text-align: right;

        svg {
          opacity: 0.5;
          transition: all 0.3s ease;
        }

        @media screen and (max-width: 768px) {
          margin-top: 8px;
        }
      }

      &-gallery {
        display: flex;
        width: 100%;
        height: calc(100% - 70px);
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        opacity: 0;
        transition: all 0.1s ease;

        img {
          display: block;
          width: calc(100% / 3 - 10px);
          height: 200px;
          object-fit: cover;
        }

        @media screen and (max-width: 768px) {
          flex-direction: column;
          height: calc(100% - 100px);

          img {
            width: 80%;
            height: calc(100% / 3 - 10px);
          }
        }
      }

      &.Inchis {
        .timeline-vertical--item-status .accent {
          color: #d40000;
        }
      }

      &.desfasurare {
        .timeline-vertical--item-status .accent {
          color: #0060f0;
        }
      }

      &.Finalizat,
      &.Done {
        background-color: $color-yellow;

        &::after {
          background-color: $color-yellow;
        }

        &:last-child {
          &::after {
            background-color: $color-grey-timeline;
          }
        }

        .timeline-vertical--item-status .accent {
          color: #039400;
        }

        .timeline-vertical--item-iconToggle svg {
          opacity: 1;
        }
      }

      &.active {
        height: 430px;
        background-color: $color-light-yellow;
        border-radius: 43px;

        @media screen and (max-width: 768px) {
          height: 80vh;
        }

        .timeline-vertical--item-iconToggle {
          svg {
            transform: rotate(180deg);
          }
        }

        .timeline-vertical--item-gallery {
          opacity: 1;
        }
      }
    }
  }

  &-form {
    form {
      margin: 0 auto;

      input[type="submit"] {
        margin: 40px auto 0;
      }
    }

    .newsletter-thanks {
      display: none;
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-size: 18px;
      line-height: 26px;
      text-align: center;
    }
  }

  .project-map2 {
    position: relative;
    display: block;
    width: 100vw;
    height: 100vh;
    margin-top: -75vh;
    z-index: 90;

    @media screen and (max-height: 850px) {
      margin-top: -90vh;
    }

    @media screen and (max-width: 760px) {
      margin-top: -75vh;
    }
  }

  p {
    display: block;
    font-family: "Poppins", sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 20px;
    color: $color-dark;

    @media screen and (min-width: 1024px) {
      font-size: 20px;
      line-height: 30px;
    }
  }

  .footer {
    display: block;
    width: 100vw;
    height: 100vh;
    margin-top: 30px;
    margin-left: 0;
    background-image: url("~@/assets/footer-bg.jpg");
    background-size: cover;
    background-position: center center;
    background-repeat: none;
    background-color: $color-light;
    text-align: center;

    // footer form fix
    @media screen and (max-height: 850px) {
      min-height: 900px;
    }

    &-shadow {
      display: block;
      width: 100vw;
      height: 100vh;
      background-color: $color-yellow;

      h2 {
        color: $color-dark;
      }
    }

    &-wrapper {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
      width: 100%;
      max-width: calc(1200px - 100px);
      height: 60%;
      margin: 200px auto 0;

      &-logo {
        display: block;
        width: 161px;
        height: 91px;
      }

      &-text {
        display: block;
        width: 17vw;
        min-width: 300px;
        // margin-left: 50px;

        h4,
        p {
          font-family: "Poppins", sans-serif;
          font-style: normal;
        }

        h4 {
          font-weight: 600;
          font-size: 38px;
          line-height: 57px;
          text-align: left;
          color: $color-yellow;
        }

        p {
          font-weight: 300;
          font-size: 18px;
          line-height: 30px;
          text-align: left;
          color: $color-light;
        }
      }

      &-form {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        width: 18vw;
        min-width: 190px;
        max-width: 350px;
        // margin-left: 10.5vw;

        h5 {
          display: block;
          margin: 0 0 30px;
          font-family: "Poppins", sans-serif;
          font-style: normal;
          font-weight: 300;
          font-size: 18px;
          line-height: 30px;
          color: $color-light;
        }

        .ask-us {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;

          input:not([type="checkbox"]),
          select,
          textarea,
          label,
          button {
            display: block;
            width: 100%;
            margin-bottom: 12px;
            font-family: "Poppins", sans-serif;
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 18px;
            letter-spacing: 0.2em;
            text-transform: uppercase;
            color: $color-yellow;
            border: 1px solid $color-yellow;
            border-radius: 80px;
            background: transparent;
            outline: none;
          }

          input {
            padding: 7px 15px;
            height: 45px;
          }

          .select-wrapper {
            display: block;
            width: 100%;
            margin-bottom: 12px;
            padding: 0 9px;
            border: 1px solid $color-yellow;
            border-radius: 80px;
            background: transparent;
          }

          select {
            margin: 0;
            padding: 7px 15px;
            height: 45px;
            border: 0px;
          }

          textarea {
            height: 80px;
            padding: 7px 15px;
            border-radius: 20px;
          }

          ::-webkit-input-placeholder {
            /* Edge */
            color: $color-yellow;
          }

          :-ms-input-placeholder {
            /* Internet Explorer 10-11 */
            color: $color-yellow;
          }

          ::placeholder {
            color: $color-yellow;
          }

          button {
            display: inline-block;
            width: auto;
            margin: 0 0 0 auto;
            padding: 7px 15px;

            &:hover {
              cursor: pointer;
              background-color: $color-yellow;
              color: $color-dark;
            }
          }
        }
      }
    }
  }

  .social-footer {
    position: relative;
    z-index: 120;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin: 120px auto;

    &-wrapper {
      display: block;
      width: 230px;
    }

    &-network {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 100%;
    }

    a {
      &:hover {
        cursor: pointer;
      }
    }

    span {
      display: block;
      margin-top: 18px;
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      text-align: center;
      letter-spacing: -0.015em;
      color: $color-dark;
      text-align: center;
    }
  }
}

.sticky {
  &-cta {
    // display: none;
    position: fixed;
    top: 55vh;
    right: 0;
    display: block;
    max-width: 175px;
    padding: 13px 26px;
    background: $color-yellow;
    border-radius: 31px 0 0 31px;
    z-index: 92;
    transform: translate3d(10px, 0, 0);
    transition: transform 0.3s ease;

    @media screen and (max-width: 768px) {
      top: 75vh;

      a {
        position: relative;
        font-size: 0 !important;

        &:after {
          content: url("~@/assets/sticky-cta-icon.svg");
          display: block;
          width: 30px;
          height: 30px;
          // transform: scale(0.5) translate3d(-20px, -38px, 0);
        }
      }
    }
  }

  &-form {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 300;
    transform: translate3d(100vw, 0, 0);
    opacity: 0;
    transition: opacity 0.3s ease;

    h6 {
      display: none;
      // margin: -50px 0 0;
      font-family: "Poppins", sans-serif;
      font-style: normal;
      font-weight: 300;
      font-size: 20px;
      line-height: 30px;
      color: $color-dark;
      text-align: left;

      @media screen and (max-width: 768px) {
        width: 70vw;
        margin: 50px auto 0;
      }
    }

    &.visible {
      opacity: 1;
      transform: translate3d(0, 0, 0);

      .sticky-form-shape {
        transform: translate3d(0, 0, 0);

        @media screen and (max-width: 768px) {
          -webkit-mask-position: -200vw -40px;
          mask-position: -200vw -40px;
        }
      }
    }

    &-shape.mask-right {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      width: 100vw;
      height: 100vh;
      background: $color-yellow;
      -webkit-mask-position: 0 center;
      mask-position: 0 center;
      transform: translate3d(100vw, 200px, 0);
      transition: transform 0.3s ease 0.4s;

      @media screen and (max-width: 768px) {
        flex-direction: column;
        padding: 60px 0;
        -webkit-mask-size: 1920px 940px;
        mask-size: 1920px 940px;
        -webkit-mask-position: 100vw 0;
        mask-position: 100vw 0;
        transition: -webkit-mask-position 0.4s ease 0.2s;
      }
    }

    &-col:nth-child(1) {
      margin: -100px 100px 0 0;

      @media screen and (max-width: 768px) {
        margin: 0 0 50px;
        transform: scale(0.7);
      }
    }

    &-col:nth-child(2) {
      margin: -50px 0 0 0;
    }

    &-col,
    form {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      h5 {
        display: block;
        width: 70%;
        font-family: "Poppins", sans-serif;
        font-style: normal;
        font-weight: 300;
        font-size: 20px;
        line-height: 30px;
        color: $color-dark;
        text-align: left;
      }
    }
  }
}

.sticky-cta {
  position: fixed;
  top: 55vh;
  right: 0;
  display: block;
  max-width: 175px;
  padding: 13px 26px;
  background: $color-yellow;
  border-radius: 31px 0 0 31px;
  z-index: 91;
  transform: translate3d(10px, 0, 0);
  transition: transform 0.3s ease;

  &:hover {
    cursor: pointer;
    transform: translate3d(0, 0, 0);

    a {
      transform: translate3d(10px, 0, 0);
    }
  }

  a {
    font-family: "Poppins", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    display: flex;
    align-items: center;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    text-decoration: none;
    color: $color-dark;
    transform: translate3d(0, 0, 0);
    transition: transform 0.3s ease;
  }
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .sticky-cta {
    a {
      &:after {
        content: "";
      }
    }
  }

  .timeline {
    .footer {
      height: 140vh;

      &.mask-right {
        -webkit-mask-size: 140vw 1000px;
        mask-size: 140vw 1000px;
      }
    }

    .footer-wrapper {
      flex-direction: column;
      height: auto;

      &-text {
        width: 40vw;
        margin: 0 auto;

        h4 {
          width: 40vw;
          margin: 20px auto;
          font-size: 23px;
          line-height: 29px;
          text-align: center;
        }

        p {
          font-size: 12px;
          line-height: 18px;
          text-align: justify;
        }
      }

      &-form {
        width: 80vw;
        margin: 20px auto 0;

        h5 {
          display: block;
          width: 100%;
          font-size: 15px;
          text-align: center;
        }
      }
    }
  }
}

@media screen and (max-width: 760px) {
  .timeline {
    .footer-wrapper {
      flex-direction: column;
      margin-top: 120px;

      &-text {
        width: 80vw;
        margin: 0 auto;

        h4 {
          width: 70%;
          margin: 0 auto;
          font-size: 23px;
          line-height: 29px;
          text-align: center;
        }

        p {
          font-size: 12px;
          line-height: 18px;
          text-align: justify;
        }
      }

      &-form {
        width: 80vw;
        margin: 0 auto;

        h5 {
          display: block;
          width: 100%;
          font-size: 15px;
          text-align: center;
        }
      }
    }

    .social-footer {
      margin: 20px auto;
    }
  }
}
</style>
